import { useEffect, useState } from 'react';
import { MONO } from './base.jsx';
import { minutes as minutesDe } from '../local/chrono.js';
import { compteurs, score } from '../logique/match.js';
import { Journal, Pause, Lecture, ButAdverse } from './icones.jsx';

/**
 * Le bandeau de match, greffé sur le Terrain.
 *
 * Il ne redessine que l'affichage : le chrono, lui, est une paire d'horodatages. Cet
 * intervalle lit `Date.now()`, il n'incrémente rien — gelé quarante minutes pendant
 * que l'écran dort, il reprend juste.
 */
export function BandeauMatch({ chrono, match, adversaire, onChrono, onButAdverse, onJournal }) {
  const [, redessiner] = useState(0);

  useEffect(() => {
    if (chrono.etat !== 'marche') return;
    const t = setInterval(() => redessiner((n) => n + 1), 500);
    return () => clearInterval(t);
  }, [chrono.etat]);

  const c = compteurs(match);
  const s = score(match);
  const min = minutesDe(chrono);
  const enMarche = chrono.etat === 'marche';

  return (
    <div style={{
      flex: 'none', display: 'flex', alignItems: 'center', gap: 8,
      padding: '7px 12px', background: 'var(--surf)',
      borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)',
    }}>
      {/* LE CHRONO, compact. Il porte la minute et se touche pour suspendre : deux
          fonctions sur une seule cible, parce que la largeur d'un téléphone se compte. */}
      <button
        onClick={onChrono}
        aria-label={enMarche ? 'Mettre le chrono en pause' : 'Reprendre le chrono'}
        style={{
          display: 'flex', alignItems: 'center', gap: 6, flex: 'none',
          height: 38, padding: '0 10px', borderRadius: 11,
          background: enMarche ? 'color-mix(in oklch, var(--bad) 18%, transparent)' : 'var(--surf2)',
          border: `1px solid ${enMarche ? 'transparent' : 'var(--line)'}`,
          color: enMarche ? 'var(--bad)' : 'var(--ink2)',
        }}
      >
        <span style={{ display: 'flex' }}>{enMarche ? <Pause /> : <Lecture />}</span>
        <span style={{ fontFamily: MONO, fontWeight: 700, fontSize: 12.5 }}>{min}&apos;</span>
      </button>

      {/* LE SCORE EST L'INFORMATION PRINCIPALE, et il avait disparu : « Mi-temps » et
          « +1 adv. » en toutes lettres mangeaient toute la largeur. Les actions sont
          passées en icônes, la mi-temps dans le menu, et le score reprend sa place. */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: '-.3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          AJA <span style={{ fontFamily: MONO }}>{s.nous}</span>
          <span style={{ color: 'var(--ink3)' }}> — </span>
          <span style={{ fontFamily: MONO }}>{s.eux}</span>
          {adversaire ? <span style={{ color: 'var(--ink2)' }}> {abrege(adversaire)}</span> : null}
        </div>
        <div style={{ fontFamily: MONO, fontSize: 9.5, color: c.epuise ? 'var(--warn)' : 'var(--ink2)', marginTop: 1 }}>
          CHG {c.changements}/5 · fen. {c.fenetres}/3
        </div>
      </div>

      <BoutonPetit onClick={onButAdverse} aria-label="But de l'adversaire">
        <ButAdverse t={16} />
      </BoutonPetit>

      <BoutonPetit onClick={onJournal} aria-label="Ouvrir le journal du match" style={{ gap: 5 }}>
        <Journal t={15} />
        <span style={{ fontFamily: MONO, fontWeight: 700 }}>{match.evenements.length}</span>
      </BoutonPetit>
    </div>
  );
}

const BoutonPetit = ({ children, style, ...r }) => (
  <button style={{ flex: 'none', minWidth: 40, height: 38, padding: '0 9px', borderRadius: 11, background: 'var(--surf2)', border: '1px solid var(--line)', fontSize: 11.5, fontWeight: 700, color: 'var(--ink2)', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }} {...r}>{children}</button>
);

// Trois lettres au-delà de six caractères : « Rennes » tient, « Strasbourg » non,
// et le score ne doit jamais être celui qui rétrécit.
const abrege = (nom) => (nom.length > 6 ? nom.slice(0, 3).toUpperCase() : nom);
